/* eslint-disable @typescript-eslint/naming-convention */
import { RxJsonSchema } from 'rxdb';
import { TableInfoModel } from '../models';
import { CentralDatabaseKeys } from './central-database-keys';
import { WorkspaceDatabaseKeys } from '../../workspace-database/schemas/workspace-database-keys';
import { AppVariables } from '@shared';

export const centralTableInfoSchema: RxJsonSchema<TableInfoModel> = {
	version: 0,
	primaryKey: {
		key: WorkspaceDatabaseKeys.columns.primaryKeyComposed,
		fields: [CentralDatabaseKeys.workFileId, CentralDatabaseKeys.tableInfo_tableName],
		separator: WorkspaceDatabaseKeys.columns.separator
	},
	properties: {
		[WorkspaceDatabaseKeys.columns.primaryKeyComposed]: {
			type: 'string',
			maxLength: AppVariables.PRIMARY_KEYS_MAX_LENGTH
		},
		[CentralDatabaseKeys.workFileId]: {
			type: 'string'
		},
		[CentralDatabaseKeys.tableInfo_tableName]: {
			type: 'string'
		},
		[CentralDatabaseKeys.tableInfo_tableType]: {
			type: 'number'
		}
	},
	type: 'object',
	description: ''
};
